export function SupportLocalStorage() {
  return typeof Storage !== "undefined";
}
